import * as React from 'react';
import styled from 'styled-components';

export const RightButton = styled.button`
  float: right;
`;

export const CenterText = styled.div`
  text-align: center;
`;

export const FormContainer = styled.div`
  padding: 20px;
  background: #efefef;
  margin: 20px 0px;
  input.full-width {
    font-size: 24px;
    box-sizing: border-box;
    margin: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    color: rgba(0, 0, 0, 0.85);
    line-height: 1.5715;
    background-color: #fff;
    background-image: none;
    border-top: none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: all 0.3s;
    max-width: 70%;
    margin-right: 10px;
  }
  input:hover {
    border-bottom: 1px solid #40a9ff;
  }

  button {
    font-size: 24px;
    padding: 7px 30px;
    border-radius: 32px;
    color: #fff;
    background: #40a9ff;
    border: none;
    transition: all 0.3s;
  }

  button:hover {
    background: #1890ff;
  }
`;

export const Container = styled.div`
  background: #ffffff;
  margin: 20px 20px 80px 20px;
  padding: 20px 20px 80px 20px;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;

  table {
    border-radius: 5px;
    width: 100%;
    border-spacing: 0px;
  }

  tr {
    background: #fff;
  }

  td {
    padding: 20px;
    border-bottom: 1px solid #333;
  }

  tr:hover {
    background: #efefef;
  }
`;

export const FullWidthTable = styled.table`
  width: 100%;
  th,
  td {
    cursor: default;
    text-align: center;
    padding: 10px;
  }

  td.clickable {
    cursor: pointer;
  }

  th {
    font-size: 20px;
  }
  tr:not(:last-child) {
    border-bottom: 1px solid #999;
  }

  tr {
    line-height: 30px;
    transition: background-color 0.35s ease;
    cursor: pointer;
    background-color: #fff;
    &:hover {
      background-color: #efefef;

      .hover-icon {
        display: inline-block;
        opacity: 1;
      }
    }

    .hover-icon {
      display: inline-block;
      opacity: 0;
      width: 16px;
      height: 16px;
    }
  }
`;

export const DefaultText = styled.span`
  color: #000000;
`;
export const ActiveText = styled.span`
  color: #27865f;
`;
export const InactiveText = styled.span`
  color: #2171d1;
`;

export const SuspendedText = styled.span`
  color: #807f7d;
`;